var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _path14, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalAuditReportPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 67,
    width: 36,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.766 95.8957L149.718 88.0888C149.908 86.5655 151.146 85.1374 153.431 83.8521C162.808 78.6633 172.233 73.4746 181.61 68.2858C182.039 68.0478 182.467 67.8098 183.038 67.4766L182.086 75.2835C181.515 75.6167 181.087 75.8547 180.658 76.0928C171.281 81.2815 161.856 86.4703 152.479 91.659C150.194 92.9443 148.956 94.3724 148.766 95.8957Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.043 67.5234L182.091 75.3304C181.52 75.6636 181.091 75.9016 180.663 76.1396C171.286 81.3284 161.861 86.5171 152.483 91.7059C152.15 91.8963 151.864 92.0867 151.531 92.2771L152.483 84.4702C152.769 84.2798 153.102 84.0894 153.435 83.899C162.813 78.7102 172.238 73.5214 181.615 68.3327C182.043 68.0947 182.472 67.8567 183.043 67.5234Z",
    fill: "#F9116C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.494 84.4688L151.542 92.2757C151.066 92.6089 150.638 92.8945 150.305 93.2277L151.257 85.4208C151.59 85.0876 152.018 84.7544 152.494 84.4688Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.252 85.4297L150.3 93.2366C150.014 93.4746 149.776 93.7603 149.586 93.9983L150.538 86.1913C150.728 85.9533 150.966 85.6677 151.252 85.4297Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.537 86.1875L149.585 93.9944C149.394 94.2324 149.251 94.4229 149.156 94.6609L150.108 86.8539C150.203 86.6159 150.394 86.4255 150.537 86.1875Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.097 86.8516L149.145 94.6585C149.05 94.8489 148.955 95.0869 148.859 95.3249L149.811 87.518C149.907 87.28 150.002 87.0896 150.097 86.8516Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.821 87.5234L148.869 95.3304C148.822 95.5208 148.774 95.7112 148.727 95.9492L149.679 88.1423C149.726 87.9043 149.774 87.7139 149.821 87.5234Z",
    fill: "#7E0434"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.049 72.9609C192.096 84.957 193.143 97.0958 194.191 109.187C183.385 102.713 172.342 96.0961 161.203 89.4317C171.247 83.8621 181.291 78.3401 191.049 72.9609Z",
    fill: "#F9116C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 89,
    width: 35,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.166 109.123L193.214 116.929C182.409 110.455 171.365 103.839 160.227 97.1741L161.179 89.3672C172.317 96.0792 183.408 102.696 194.166 109.123Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.166 109.123L193.214 116.929C182.409 110.455 171.365 103.839 160.227 97.1741L161.179 89.3672C172.317 96.0792 183.408 102.696 194.166 109.123Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 88,
    width: 18,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9014 98.6295L72.9494 106.436C67.3325 103.057 61.7632 99.772 56.2891 96.4397L57.2411 88.6328C62.7628 91.965 68.2845 95.2973 73.9014 98.6295Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9014 98.6295L72.9494 106.436C67.3325 103.057 61.7632 99.772 56.2891 96.4397L57.2411 88.6328C62.7628 91.965 68.2845 95.2973 73.9014 98.6295Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 95,
    width: 19,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.425 105.308L113.473 113.115C107.904 109.783 102.382 106.499 96.8125 103.166L97.7645 95.3594C103.334 98.6916 108.856 101.976 114.425 105.308Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.425 105.308L113.473 113.115C107.904 109.783 102.382 106.499 96.8125 103.166L97.7645 95.3594C103.334 98.6916 108.856 101.976 114.425 105.308Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 113,
    width: 2,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.994 113.664L186.042 121.471C185.709 121.661 185.519 121.804 185.328 121.899L186.28 114.092C186.518 113.997 186.661 113.902 186.994 113.664Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.994 113.664L186.042 121.471C185.709 121.661 185.519 121.804 185.328 121.899L186.28 114.092C186.518 113.997 186.661 113.902 186.994 113.664Z",
    fill: "#F9116C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 102,
    width: 18,
    height: 18
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.917 112.059L153.965 119.866C148.396 116.534 142.874 113.249 137.305 109.869L138.257 102.062C143.826 105.395 149.348 108.727 154.917 112.059Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.917 112.059L153.965 119.866C148.396 116.534 142.874 113.249 137.305 109.869L138.257 102.062C143.826 105.395 149.348 108.727 154.917 112.059Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 88,
    width: 25,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.228 88.6797L56.276 96.4866C48.6598 100.676 41.0913 104.865 33.5703 109.006L34.5223 101.199C42.0433 97.0579 49.6119 92.8688 57.228 88.6797Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.228 88.6797L56.276 96.4866C48.6598 100.676 41.0913 104.865 33.5703 109.006L34.5223 101.199C42.0433 97.0579 49.6119 92.8688 57.228 88.6797Z",
    fill: "#F9116C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 98,
    width: 4,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01791 106.729L6.96993 98.9219C6.82712 100.255 7.49354 101.683 9.01677 103.254C9.11197 103.349 9.11197 103.444 9.15957 103.539L8.20755 111.346C8.15995 111.251 8.15995 111.156 8.06475 111.061C6.58912 109.49 5.8751 108.062 6.01791 106.729Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16054 103.571L8.20851 111.378C8.16091 111.282 8.16091 111.187 8.06571 111.092C6.54248 109.521 5.87606 108.045 6.01887 106.76L6.97089 98.9531C6.82809 100.286 7.4945 101.714 9.01773 103.285C9.11293 103.38 9.11293 103.475 9.16054 103.571Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 95,
    width: 40,
    height: 30
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7494 95.3359L96.7974 103.143C84.0879 110.141 71.4736 117.091 58.8594 124.041L59.8114 116.234C72.3781 109.331 85.0399 102.381 97.7494 95.3359Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7494 95.3359L96.7974 103.143C84.0879 110.141 71.4736 117.091 58.8594 124.041L59.8114 116.234C72.3781 109.331 85.0399 102.381 97.7494 95.3359Z",
    fill: "#F9116C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 102,
    width: 55,
    height: 38
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.216 102.062L137.264 109.869C119.461 119.676 101.754 129.434 84.0938 139.193L85.0458 131.386C102.753 121.627 120.413 111.869 138.216 102.062Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.216 102.062L137.264 109.869C119.461 119.676 101.754 129.434 84.0938 139.193L85.0458 131.386C102.753 121.627 120.413 111.869 138.216 102.062Z",
    fill: "#F9116C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 103,
    width: 89,
    height: 61
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4476 155.807L95.4956 163.614C66.4114 146.191 37.3271 128.768 8.19531 111.393L9.14733 103.586C38.2316 121.009 67.3634 138.384 96.4476 155.807Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4476 155.807L95.4956 163.614C66.4114 146.191 37.3271 128.768 8.19531 111.393L9.14733 103.586C38.2316 121.009 67.3634 138.384 96.4476 155.807Z",
    fill: "#7E0434"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.337 114.133C161.108 128.033 135.879 141.933 110.651 155.833C107.652 157.5 102.702 157.69 98.4175 156.405C97.751 156.214 97.1322 156.024 96.4658 155.833C67.3816 138.363 38.2497 120.988 9.16552 103.565C9.11792 103.47 9.11792 103.375 9.02272 103.279C5.83345 99.9472 6.30946 97.2814 10.4983 94.9964C45.6755 75.5743 80.8527 56.1998 116.03 36.8253C120.98 34.1119 127.644 34.4451 133.071 37.6821C149.255 47.3456 165.44 57.009 181.576 66.7201C182.052 67.0057 182.528 67.2913 183.052 67.6246C182.481 67.9578 182.052 68.1958 181.624 68.4338C172.247 73.6226 162.822 78.8113 153.444 84.0001C148.161 86.9039 148.494 90.7121 154.349 94.2348C164.726 100.471 175.103 106.659 185.527 112.895C186.051 113.181 186.527 113.514 187.051 113.8C186.67 113.895 186.527 113.99 186.337 114.133ZM101.75 141.314C119.505 131.508 137.212 121.797 154.92 111.991C149.351 108.659 143.829 105.374 138.26 101.994C120.457 111.8 102.749 121.559 85.0892 131.318C90.7061 134.745 96.2278 138.03 101.75 141.314ZM76.4734 126.224C89.1828 119.226 101.75 112.276 114.411 105.326C108.842 101.994 103.32 98.7095 97.751 95.3773C85.0416 102.375 72.4273 109.325 59.813 116.275C65.4299 119.607 70.9517 122.94 76.4734 126.224ZM51.1972 111.134C58.7658 106.945 66.2868 102.803 73.9029 98.6143C68.286 95.2345 62.7167 91.9498 57.2426 88.6176C49.6264 92.8067 42.0578 96.9958 34.5369 101.137C40.1538 104.517 45.6279 107.849 51.1972 111.134Z",
    fill: "#F9116C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 114,
    width: 92,
    height: 52
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.338 114.125L185.386 121.932C160.158 135.832 134.929 149.732 109.701 163.632C106.702 165.298 101.751 165.489 97.4673 164.204C96.8009 164.013 96.182 163.823 95.5156 163.632L96.4676 155.825C97.1341 156.016 97.7529 156.206 98.4193 156.397C102.656 157.682 107.654 157.492 110.653 155.825C135.881 141.925 161.11 128.025 186.338 114.125Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.343 114.125L185.391 121.932C160.162 135.832 134.933 149.732 109.705 163.632C109.372 163.823 108.991 164.013 108.562 164.156L109.515 156.349C109.943 156.206 110.324 156.016 110.657 155.825C135.885 141.925 161.114 128.025 186.343 114.125Z",
    fill: "#F9116C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.51 156.359L108.558 164.166C107.844 164.452 107.083 164.642 106.273 164.785L107.225 156.978C108.035 156.835 108.796 156.597 109.51 156.359Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.232 156.969L106.28 164.776C105.471 164.919 104.662 165.014 103.805 165.014L104.757 157.207C105.566 157.207 106.423 157.112 107.232 156.969Z",
    fill: "#F9116C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.704 157.203L103.752 165.01C103.228 165.01 102.657 165.01 102.086 165.01L103.038 157.203C103.609 157.203 104.18 157.203 104.704 157.203Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.082 157.205L102.13 165.012C101.654 164.965 101.178 164.965 100.75 164.869L101.702 157.062C102.13 157.11 102.606 157.158 103.082 157.205Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.659 157.065L100.707 164.872C100.279 164.825 99.8503 164.73 99.4219 164.682L100.374 156.875C100.802 156.923 101.231 157.018 101.659 157.065Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.416 156.864L99.4642 164.671C99.0358 164.575 98.655 164.48 98.2266 164.385L99.1786 156.578C99.5594 156.673 99.9878 156.769 100.416 156.864Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1809 156.598L98.2289 164.405C97.9909 164.357 97.7053 164.262 97.4673 164.214C96.8009 164.024 96.182 163.833 95.5156 163.643L96.4676 155.836C97.1341 156.026 97.7529 156.217 98.4193 156.407C98.6573 156.455 98.9429 156.55 99.1809 156.598Z",
    fill: "#7E0434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalAuditReportPink);
export default __webpack_public_path__ + "static/media/final-audit-report-pink.2a6f761534a91715569dfd86b5ccd69e.svg";
export { ForwardRef as ReactComponent };